import { buildInitialExportName } from '@/features/DataHub/modules/Export/services/ExportNameService';
import { sanitizeFilenamePart } from '@/utils/exportFileDateSuffix';

const DEFAULT_EXPORT_BASE_NAME = 'GX-Chart';

export const buildCustomChartInitialExportName = (baseName: string): string => {
  return buildInitialExportName(baseName, DEFAULT_EXPORT_BASE_NAME);
};

export const buildCustomChartExportFileName = (exportName: string, dateSuffix: string): string => {
  const baseName = buildCustomChartInitialExportName(exportName);
  const sanitizedDateSuffix = sanitizeFilenamePart(dateSuffix);

  if (!sanitizedDateSuffix) return baseName;
  return `${baseName}-${sanitizedDateSuffix}`;
};
